export class Category {
  id = '';
  name = '';
  machines: Machine[] = [];
}

export class Machine {
  id = '';
  manufacturer = '';
  model = '';
  picData = '';
  picUrl = '';
  port: '';
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/models/category.ts